import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = ["onKeydown", "tabindex", "aria-expanded", "id", "aria-controls"]
const _hoisted_3 = ["inert", "id"]

import {ref, watch, onMounted, useTemplateRef, useId} from 'vue';
  import * as scrollTo from 'scroll-to';

  
  interface AccordionProps {
    initialOpen?: boolean;
    foldOut?: boolean;
    useMaxHeight?: boolean;
    anchor?: string;
  }

  export {AccordionProps};

export default /*@__PURE__*/_defineComponent({
  __name: 'accordion',
  props: {
    initialOpen: { type: Boolean, default: false },
    foldOut: { type: Boolean, default: false },
    useMaxHeight: { type: Boolean, default: true },
    anchor: { default: null }
  },
  setup(__props: any) {

  const props = __props;

  const isOpen = ref(props.initialOpen || props.foldOut);
  const accordionEl = useTemplateRef('accordion');
  const accordionContentEl = useTemplateRef('accordionContent');
  const uid = useId();

  watch(() => props.initialOpen, (initialOpen) => {
    isOpen.value = initialOpen || props.foldOut;
    resizeContent();
  });

  onMounted(() => {
    const hash = document.location.hash;
    window.addEventListener('resize', () => {
      resizeContent();
    });
    if (props.anchor && hash.indexOf(props.anchor) >= 0) {
      isOpen.value = true;
      const accordion = accordionEl.value;
      const accordionRect = accordion.getBoundingClientRect();
      if (accordionRect && accordionRect.top) {
        const bodyRect = document.body.getBoundingClientRect();
        const offsetTop = accordionRect.top - bodyRect.top - 70;
        scrollTo(0, offsetTop, {duration: 500});
      }
    }
  });

  function resizeContent() {
    setMaxHeight();
  }

  function toggleClass() {
    if (props.foldOut) {
      return;
    }
    isOpen.value = !isOpen.value;
    setMaxHeight();
  }

  function setMaxHeight() {
    if (!props.useMaxHeight) return;

    const accordionContent = accordionContentEl.value;
    if (isOpen.value && accordionContent?.children) {
      const hasLazyContent = accordionContent.querySelector('.lazy-load, [loading="lazy"]') !== null;
      if (hasLazyContent) {
        accordionContent.style.maxHeight = '2000px';
      } else {
        accordionContent.style.maxHeight = (<HTMLElement>accordionContent.children[0]).offsetHeight + 'px';
      }
    }
    else {
      accordionContent.style.maxHeight = '0';
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accordion", {
      'accordion--open': isOpen.value,
      'accordion--closed': !isOpen.value,
      'accordion--hide-arrow': _ctx.foldOut,
    }]),
    id: _ctx.anchor,
    ref: "accordion",
    role: "presentation",
    "aria-labelledby": `${_unref(uid)}_head`
  }, [
    _createElementVNode("div", {
      class: "accordion__headline",
      onClick: toggleClass,
      onKeydown: _withKeys(_withModifiers(toggleClass, ["prevent"]), ["enter","space"]),
      role: "button",
      tabindex: _ctx.foldOut === false ? 0 : null,
      "aria-expanded": isOpen.value,
      id: `${_unref(uid)}_head`,
      "aria-controls": `${_unref(uid)}_section`
    }, [
      _renderSlot(_ctx.$slots, "head")
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", {
      class: "accordion__content",
      inert: !isOpen.value,
      id: `${_unref(uid)}_section`,
      ref: "accordionContent"
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 8 /* PROPS */, _hoisted_3)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})